<div class="categories"
     *ngIf="identityService.isCompanyAdmin()"
>
  <div class="category"
       *ngFor="let category of categories"
       (click)="onChooseItemsByCategory(category)"
       [class.chosen-category]="category.isChosenForSorting"
       [class.uncategorized]="isCategoryContainsUncategorized(category)"
  >
      <span class="category-name" *ngIf="!category.isEditMode">
        {{ category.Name }}
      </span>

    <div class="amount-of-objects" *ngIf="isDisplayAmountOfObjects(category)">
      {{ category.amountOfObjects }}
    </div>

    <input
      *ngIf="category.isEditMode"
      [value]="category.Name"
      (change)="onChangeNameOfCategory($event, category)"
      meeInputAutofocus
      matInput
      type="text"
      class="category-rename">


    <div class="more-options"
         *ngIf="!category.isChosenForSorting && !isCategoryContainsUncategorized(category)"
         [class.onHover]="category.isShowMoreOptions">
      <button mat-icon-button
              (click)="onClickMoreOptionsMenu($event)"
              (onMenuOpen)="onOpenMoreOptions($event, category)"
              (onMenuClose)="onCloseMoreOptions(category)"
              [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onRenameCategory(category)">
          <mat-icon>edit</mat-icon>
          <span>{{ 'categories.actions.rename' | translate }}</span>
        </button>
        <button mat-menu-item (click)="onDeleteCategory(category)">
          <mat-icon>delete</mat-icon>
          <span>{{ 'categories.actions.clean' | translate }}</span>
        </button>
      </mat-menu>
    </div>


  </div>
</div>
